import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Player } from '@lottiefiles/react-lottie-player'
import Loading from '@assets/lottie/chart.json'
import { useTranslation } from 'react-i18next'

export const Bridge = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/main', { replace: true })
    }, 1500)

    return () => clearTimeout(timer)
  }, [])

  return (
    <div className={'flex h-screen items-center justify-center bg-white text-center'}>
      <div className={'pb-[3rem]'}>
        <Player autoplay loop src={Loading} style={{ height: 160, width: 160 }} />
        <div>
          <h3 className={'text-18 text-navy-900 font-bold'}>{t('bridge.title')}</h3>
          <p className={'text-12 text-navy-500 mt-8'}>
            {t('bridge.descriptionLine1')}
            <br />
            {t('bridge.descriptionLine2')}
            <br />
            {t('bridge.descriptionLine3')}
          </p>
        </div>
      </div>
    </div>
  )
}
